import { FC } from "react";

import { ShapeP, ShapeSquare } from "assets/icons";

import s from "./Shapes.module.scss";

interface Props {
  children?: React.ReactNode;
}

export const Shapes: FC<Props> = ({ children }) => {
  return (
    <div className={s.Shapes}>
      {children}
      <div className={s.ShapeP}>
        <ShapeP />
      </div>
      <div className={s.ShapeSquare}>
        <ShapeSquare />
      </div>
    </div>
  );
};
